import InputAreaController from './InputAreaController'

export default InputAreaController
